import { Environment } from 'config';
import jwt, { Algorithm } from 'jsonwebtoken';

export const capitalizeFirstLetter = (s: string | undefined) => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const replaceElementWith = (
  inputString: string,
  replaceThis: string,
  withThis: string
) => {
  let re = new RegExp(`${replaceThis}`, 'gi');
  return inputString.replace(re, withThis);
};

export function shortenName(name: string) {
  if (name) {
    return name
      .split(' ')
      .map((n: string, index: number) => {
        if (index < 2) {
          return n[0];
        }
      })
      .join('');
  } else {
    return '';
  }
}

export function extractContent(s: string) {
  var span = document.createElement('span');
  span.innerHTML = s;
  return span.textContent || span.innerText;
}

export function encodeWithHash(text: string) {
  const secretHashKey = Environment.SECRET_KEY;
  const jwtOptions = {
    issuer: 'Harry Nguyen',
    subject: 'Hash request value',
    algorithm: 'RS256' as Algorithm,
  };

  let token = jwt.sign({ value: text }, secretHashKey, jwtOptions);
  return token;
}

export function toPercentage(text: string | null) {
  if (text) {
    let result = text;
    const pattern = new RegExp('[0-9].[0-9]+( |):( |)[0-9]', 'g');
    const array = [...text.matchAll(pattern)];
    for (let index = 0; index < array.length; index++) {
      const current = array[index];
      const extracted = current[0].replace(',', '.').split(':');
      const formatted = (Number(extracted[0]) / Number(extracted[1])) * 100;
      result = result.replace(current[0], formatted.toString());
    }
    return result;
  }
  return '';
}
